import { Artist, ArtistRegisterStatus } from '@favid-inc/api';
import { Action } from 'core/generic';
import React from 'react';
import styled from 'styled-components';

function Content({ artist, onOpenModalIugo }: { artist: Artist, onOpenModalIugo: () => void }) {
  const { photoUri, registerStatus } = artist;

  const statusLabelMap: Record<ArtistRegisterStatus, string> = {
    [ArtistRegisterStatus.APPROVED]: 'Aprovado',
    [ArtistRegisterStatus.DENIED]: 'Negado',
    [ArtistRegisterStatus.INCOMPLETE]: 'Incompleto',
    [ArtistRegisterStatus.PENDING]: 'Pendente Aprovação',
  };

  const status: string = (registerStatus && statusLabelMap[registerStatus]) ?? '';

  return (
    <Card className='ui card'>
      <div className='ui small centered image'>
        <img src={photoUri} alt='artista' />
      </div>
      <div className='extra content '>
        <Details>
          <div>Cadastro {status}</div>
        </Details>
      </div>
    </Card>
  );
}

interface Params {
  artist: Artist;
  onOpenModalIugo: () => void;
  dispatch: (action: Action) => void;
}

export const ArtistCard = (params: Params) => {
  const { artist, onOpenModalIugo } = params;
  return (
    <div>
      <div className='header'>
        <h3>Detalhes do Artista</h3>
      </div>
      <div className='ui equal width grid' style={{ marginTop: '1em' }}>
        <div className='column'>
          <Content artist={artist} onOpenModalIugo={onOpenModalIugo} />
        </div>
      </div>
    </div>
  );
};

const Card = styled.div`
  margin: 0 auto !important;
`;

const Details = styled.div`
  text-align: center;
`;
